/**
 *  AWS Amplify - Currently, the newest versions of Angular (6+) do not provide the shim for the
 *   global object which was provided in previous versions.
 *   https://ui.docs.amplify.aws/angular/getting-started/troubleshooting
 */
(window as any).global = window;
(window as any).process = {
  env: { DEBUG: undefined }
};
